// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PicLeftOutlinedSvg from "@fishx/icons-svg/es/asn/PicLeftOutlined";
import FishxIcon from '../components/FishxIcon';

var PicLeftOutlined = function PicLeftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PicLeftOutlinedSvg
  }));
};

PicLeftOutlined.displayName = 'PicLeftOutlined';
export default React.forwardRef(PicLeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PicLeftOutlined.js
// module id = 3782
// module chunks = 0